import { render, staticRenderFns } from "./vips_modal.vue?vue&type=template&id=2e15b26e&"
import script from "./vips_modal.vue?vue&type=script&lang=ts&"
export * from "./vips_modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports